var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
var SurveyQuestionImageMap = /** @class */ (function (_super) {
    __extends(SurveyQuestionImageMap, _super);
    function SurveyQuestionImageMap(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { width: undefined, height: undefined, scale: undefined };
        return _this;
    }
    Object.defineProperty(SurveyQuestionImageMap.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionImageMap.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
    };
    SurveyQuestionImageMap.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
    };
    SurveyQuestionImageMap.prototype.renderElement = function () {
        var _this = this;
        return (React.createElement("div", { className: this.question.cssClasses.root, ref: function (root) { return (_this.setControl(root)); } },
            React.createElement("img", { className: this.question.cssClasses.bg, id: "".concat(this.question.id, "-bg"), src: this.question.imageLink, role: "presentation" }),
            React.createElement("svg", { className: this.question.cssClasses.svg, id: "".concat(this.question.id, "-svg") })));
    };
    return SurveyQuestionImageMap;
}(SurveyQuestionElementBase));
export { SurveyQuestionImageMap };
ReactQuestionFactory.Instance.registerQuestion("imagemap", function (props) {
    return React.createElement(SurveyQuestionImageMap, props);
});
